// export const BACKEND_API = "https://attention-snatcher-backend.onrender.com";
export const BACKEND_API = "http://localhost:3002";